import { fileTypes, orgTypes, statusTypes, usersTypes } from "@/store/modules/consts"
import { api } from "@/main"

const state = {
  member_id: -1,
  card_number: -1,
  claimsBag: [],
  logged: false,
  user: {
    username: "",
    profile: {}
  },
  seeClaimsForm: false,
  soundRecordingTableFlags: {
    myClaims: false,
    myConflicts: false,
    unclaimed: false
  },
  dataReady: false, // Flag after initial http data collection
  soundrecordingTable: {
    columns: {
      basic: ["title", "artist", "isrc", "duration", "play_count"],
      editable: ["claimed", "title", "artist", "isrc", "duration", "play_count"]
    }
  },
  users_types: usersTypes,
  orgTypes,
  rights: [],
  current_right: "",
  srTypes: [],
  membersList: [],
  countries: [],
  current_country: "",
  right_owners: [],
  current_rightowner: null,
  claimers: [],
  current_claimer: null,
  claims_bag_counter: 0,
  current_licencee_right_owner: "",
  mandates: [],
  allSoundRecordingMarked: false,
  can_save_claim: false,
  can_edit_soundrecording_table: false,
  panel_member: {},
  panel_mandates: [],
  panelUser: {},
  pageNotFound: false,
  waiting: false,
}

const getters = {
  user_id: state => {
    return state.user.profile.user
  },
  countries: state => state.countries,
  srTypes: state => state.srTypes,
  orgTypes: state => state.orgTypes,
  membersList: state => state.membersList,
  distributionRules: state => state.distributionRules,
  userProfile: state => state.user,
  isLogged: state => {
    return state.logged
  },
  userRole: (state, getters) => {
    return getters.isMlc ? getters.userType : "MEMBER"
  },
  img64: state => {
    return state.user.avatar
  },
  memberLogo: state => {
    try {
      let member = state.user.member
      if (member.logo !== "") {
        return "data:image/png;base64, " + member.logo
      } else {
        return ""
      }
    } catch (err) {
      return ""
    }
  },
  isSuperUser: (state, getters) => {
    return state.user.profile.user_type === "ADMIN" && getters.isMlc
  },
  isAdvanced: state => {
    return state.user.profile.user_type === "ADVANCED"
  },
  isBasic: state => {
    return state.user.profile.user_type === "BASIC"
  },
  hasMandate: state => {
    return (
      state.can_edit_soundrecording_table !== undefined &&
      state.can_edit_soundrecording_table
    )
  },
  user_name: (state, getters) => {
    let username = state.user.profile.name_and_last_name

    if (getters.isMlc) {
      let role = getters.userRole

      return `${username} (${role})`
    } else {
      return username
    }
  },
  organization: state => {
    try {
      let username = state.user.profile.member.username

      return username
    } catch (err) {
      return ""
    }
  },

  userType: state => {
    return state.user.profile.user_type
  },
  isMlc: state => {
    return state.user.profile.is_mlc
  },
  isSisterSociety: state => {
    return state.user.profile.is_sister_society_role
  },
  isAdmin: state => {
    return state.user.profile.user_type === "ADMIN"
  },
  statusTypes: () => statusTypes,
  fileTypes:  () => fileTypes
}

const mutations = {
  waiting (state, waiting) {
    state.waiting = waiting
  },
  setLogged (state, value) {
    state.logged = value
  },
  setUser (state, user) {
    state.user = user
    state.mandates = user.mandates
    state.current_country = user.member.nationality
    state.can_edit_soundrecording_table =
      state.user.mandates !== undefined &&
      Object.keys(state.user.mandates).length > 0
  },
  setRights (state, rights) {
    state.rights = rights
    state.current_right = rights[0]
  },

  setCountries (state, countries) {
    state.countries = countries
  },
  setSrTypes (state, srTypes) {
    state.srTypes = srTypes
  },
  setMembersList (state, membersList) {
    state.membersList = membersList
  },
  setClaimers (state, claimers) {
    state.claimers = claimers
  },
  setRightOwners (state, rightowners) {
    state.right_owners = rightowners
  },

  setDataReady (state, value) {
    state.dataReady = value
  },

  setConflicts (state, value) {
    state.conflicts = value.results
  },

  setPageNotFound (state, pageNotFound) {
    state.pageNotFound = pageNotFound
  }
}

const actions = {
  getConflicts ({ commit }) {
    api.get("conflicts/").then(
      resp => {
        commit("setConflicts", resp.data)
      },
      err => window.console.log(err)
    )
  },
  getCountries ({ commit }) {
    api.get("countries/").then(
      resp => {
        commit("setCountries", resp.data)
      },
      err => window.console.log(err)
    )
  },
  getSrTypes ({ commit }) {
    api.get("soundrecordingtypes/").then(
      resp => {
        commit("setSrTypes", resp.data.results)
      },
      err => window.console.log(err)
    )
  },
  getMembersList ({ commit }) {
    api.get("members/").then(
      resp => {
        commit("setMembersList", resp.data)
      },
      err => window.console.log(err)
    )
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
